'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { Heading, Button, TextPassage, usePrevious } from '../../index.js';
export const EditableSection = React.forwardRef((_a, ref) => {
    var { buttonText, buttonCloseText, children, className, description, isActive, title, behavior, titleAfter, onClick, showButton = true } = _a, other = __rest(_a, ["buttonText", "buttonCloseText", "children", "className", "description", "isActive", "title", "behavior", "titleAfter", "onClick", "showButton"]);
    const [isActiveVar, setIsActiveVar] = React.useState(isActive || false);
    const buttonRef = React.useRef(null);
    const handleClick = (e) => {
        if (behavior === 'static' || onClick) {
            if (onClick) {
                onClick(e);
            }
        }
        else {
            setIsActiveVar(!isActiveVar);
        }
    };
    const prevIsActive = usePrevious(isActive);
    React.useEffect(() => {
        if (prevIsActive !== undefined || null) {
            if (isActive) {
                setIsActiveVar(true);
            }
            else {
                setIsActiveVar(false);
            }
        }
    }, [isActive, prevIsActive]);
    const componentClassName = classnames('sparky-c-editable-section', className, {
        'sparky-is-active': isActiveVar === true,
    });
    return (_jsxs("section", Object.assign({ className: componentClassName, ref: ref }, other, { children: [_jsxs("header", Object.assign({ className: "sparky-c-editable-section__header" }, { children: [_jsxs("div", Object.assign({ className: "sparky-c-editable-section__left" }, { children: [_jsxs("div", Object.assign({ className: "sparky-c-editable-section__left-title" }, { children: [_jsx(Heading, Object.assign({ tagName: "h2", size: "headline", className: "sparky-c-editable-section__title" }, { children: title })), titleAfter && (_jsx("div", Object.assign({ className: "sparky-c-editable-section__title-after" }, { children: titleAfter })))] })), description && (_jsx(TextPassage, Object.assign({ className: "sparky-c-editable-section__description" }, { children: description }))), behavior === 'static' && (_jsx("div", Object.assign({ className: "sparky-c-editable-section__content" }, { children: children })))] })), showButton && (_jsx(_Fragment, { children: !isActiveVar && (_jsx(Button, { variant: "link", text: isActiveVar ? buttonCloseText || buttonText : buttonText, className: "sparky-c-editable-section__button", onClick: handleClick, buttonRef: buttonRef, size: "lg", "aria-expanded": isActiveVar && behavior !== 'static' ? true : false })) }))] })), behavior !== 'static' && (_jsx("div", Object.assign({ className: "sparky-c-editable-section__body", hidden: !isActiveVar }, { children: children })))] })));
});
EditableSection.displayName = 'EditableSection';
//# sourceMappingURL=EditableSection.js.map